var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4194 40.8399C31.6967 40.8399 40.8387 31.7098 40.8387 20.4473C40.8387 9.18478 31.6967 0.0546875 20.4194 0.0546875C9.14207 0.0546875 0 9.18478 0 20.4473C0 31.7098 9.14207 40.8399 20.4194 40.8399Z",
    fill: "#F7D581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5554 0C20.5554 0 17.3305 22.8006 0.964844 26.5631C2.10528 29.2294 3.55159 31.7546 5.27476 34.088C5.27476 34.088 25.7243 27.8724 28.4217 6.18551C28.5709 4.6216 28.5355 3.04559 28.3163 1.48994C27.1361 0.984221 25.8763 0.688803 24.5941 0.617052L20.5554 0Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.982 3.15918C30.982 3.15918 33.3027 26.0501 8.49805 37.0817C11.1417 39.2031 14.3571 40.4917 17.7357 40.7839C22.9596 37.3974 27.5498 33.124 31.2984 28.1571C35.4577 22.709 38.1551 17.0201 38.0798 10.3681C36.4933 7.30713 34.0198 4.79486 30.982 3.15918Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.0448 12.249C39.0448 12.249 41.4408 17.8927 34.6896 28.0063C29.4605 35.8172 25.9492 38.18 21.127 40.9943C24.3408 40.9046 27.4786 39.9982 30.2441 38.3606C33.528 36.4559 36.312 33.7995 38.3666 30.6099C40.3106 27.2538 40.4764 25.5682 40.9586 20.5566C40.9345 19.0067 40.7833 17.4615 40.5065 15.9363C40.1677 14.6535 39.677 13.4157 39.0448 12.249Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.63994 20.7821C9.84547 20.7821 11.6334 18.9965 11.6334 16.7939C11.6334 14.5913 9.84547 12.8057 7.63994 12.8057C5.43442 12.8057 3.64648 14.5913 3.64648 16.7939C3.64648 18.9965 5.43442 20.7821 7.63994 20.7821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.3528 11.2118C20.5584 11.2118 22.3463 9.42621 22.3463 7.22358C22.3463 5.02094 20.5584 3.23535 18.3528 3.23535C16.1473 3.23535 14.3594 5.02094 14.3594 7.22358C14.3594 9.42621 16.1473 11.2118 18.3528 11.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.3133 10.4911C18.9113 10.4911 20.2067 9.19737 20.2067 7.6015C20.2067 6.00562 18.9113 4.71191 17.3133 4.71191C15.7153 4.71191 14.4199 6.00562 14.4199 7.6015C14.4199 9.19737 15.7153 10.4911 17.3133 10.4911Z",
    fill: "#62412A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.56915 19.6112C8.16712 19.6112 9.46252 18.3175 9.46252 16.7216C9.46252 15.1257 8.16712 13.832 6.56915 13.832C4.97119 13.832 3.67578 15.1257 3.67578 16.7216C3.67578 18.3175 4.97119 19.6112 6.56915 19.6112Z",
    fill: "#62412A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar1);
export default __webpack_public_path__ + "static/media/boba-avatar-1.5478d7d6.svg";
export { ForwardRef as ReactComponent };